import { Link } from "react-router-dom";
import styles from "./FooterLinkGroup.module.scss";

const FooterLinkGroup = ({ title, links }) => (
  <div className={styles.group}>
    <span className={styles.title}>{title}</span>
    {links.map((link, index) => (
      <Link key={index} to={link.url} className={styles.link}>
        {link.text}
      </Link>
    ))}
  </div>
);


export default FooterLinkGroup;